<template>
  <div class="register">
    <div class="tip boxStyle">
      <p>温馨提示：</p>
      <p>开通需要后台人员审批，审批通过后方可使用。请耐心等待！</p>
      
    </div>
    <van-form ref="form" @submit="onSubmit">
      <div class="optionItem boxStyle">
        <van-field
          :value="personInfo.personCode"
          name="personCode"
          readonly
          label="工号"
          placeholder="请输入工号(必填项)"
          :rules="[{ required: true}]"
        />
        <van-field
          :value="personInfo.personName"
          name="personName"
          label="姓名"
          readonly
          placeholder="请输入姓名(必填项)"
          :rules="[{ required: true}]"
        />
        <van-field
          v-model="personInfo.orgName"
          name="orgName"
          label="绑定单位"
          readonly
          clickable
          is-link
          required
          @click="orgStatus = true"
          placeholder="请选择单位(必选项)"
          :rules="[{ required: true}]"
        />
        <!-- :rules="[{ required: false }, {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的联系方式'}]" -->
        <div  class="btn">
          <van-button round block  type="info"  native-type="submit">注册</van-button>
        </div>
       </div>
      
    </van-form>
    <van-popup v-model="orgStatus" :close-on-click-overlay="false"  position="bottom">
      <van-picker
        title="单位"
        show-toolbar
        :columns="orgList"
        @confirm="orgConfirm"
        @cancel="orgStatus = false"
        valueKey="orgName"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      personInfo: {
        personCode: '234435',
        personName: '张三',
      },
      orgStatus: false,
      orgList: [{orgName: '千方', orgId: 1},]
    }
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values);
      localStorage.setItem('personInfo', JSON.stringify(values))
      this.$toast.success('注册成功')
      setTimeout(() => {
        this.$router.back()
      }, 1500)
    },
    orgConfirm (e) {
      if (e) {
        this.personInfo.orgName = e.orgName
        this.personInfo.orgId = e.orgId
      }
      this.orgStatus = false
    }
  }
}
// #eef0fc
</script>
<style scoped lang="less">
.boxStyle {
  
  border-radius: 10px;
  box-shadow: 0 0 13px 4px rgba(156, 156, 156, 0.223);
}

.register {
  height: 100vh;
  overflow-y: auto;
  background-color: #fcfffc;
  padding: 13px 20px;
}
.optionItem {
  background-color: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-top: 10px;
  h3 {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content:space-between;
    margin-bottom: 10px;
  }
  .btn {
    margin: 16px;
    margin-top: 35px
  }
}
.tip {
  background-color: #fff;
  border-left: 4px solid #29a0fa;
  padding: 10px;
  p {
    color: #676767;
    &:first-child {
      font-weight: bold;
    }
    &:last-child {
      text-indent: 14px;
      margin-top: 5px;
    }
  }
}
</style>